var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 11.3137,
    height: 11.3137,
    rx: 2,
    transform: "rotate(45 8 0)",
    fill: "#00ED76",
    stroke: "black",
    strokeWidth: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88281 7.7445L4.88551 7.74324L7.97925 9.55397V9.55406L7.97933 9.55401L7.97941 9.55406V9.55397L11.0731 7.74324L11.0758 7.7445L11.0745 7.7424L11.0758 7.74166L11.0734 7.74056L7.97941 2.57547V2.5752L7.97933 2.57533L7.97925 2.5752V2.57547L4.88517 7.74056L4.88281 7.74166L4.88407 7.7424L4.88281 7.7445ZM7.97933 10.2212L4.88281 8.36475L7.97925 12.8101V12.8103L7.97933 12.8102L7.97941 12.8103V12.8101L11.0758 8.36475L7.97933 10.2212Z",
    fill: "#131313"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeth);
export default __webpack_public_path__ + "static/media/icon-deth.667f2c30.svg";
export { ForwardRef as ReactComponent };